import { useEffect, useState } from "react";

import styled from "styled-components/macro";

import { AnimatePresence, motion } from "framer-motion";

export default function CircleCheck({ checked = true }) {
  const [width, height, stroke] = [10, 16, 4];

  const [changeCount, setChangeCount] = useState(-1);

  useEffect(() => {
    setChangeCount((currentVal) => currentVal + 1);
  }, [checked]);

  return (
    <Container
      data-cy="FnrCircleCheck"
      className={checked && "on"}
      initial={{ scale: 1 }}
      animate={{
        scale: changeCount > 0 && checked ? [1, 1.1, 1] : 1,
        transition: { delay: 0.22, duration: 0.2 },
      }}
    >
      <Background />
      <CheckedBackground />
      <Border />
      <CheckMarkOverflow>
        <CheckMarkHolder>
          {width && height && stroke && (
            <AnimatePresence>
              {checked && (
                <>
                  <CheckLine1
                    data-cy="checkmarkStroke1"
                    key="check1"
                    style={{ height: stroke }}
                    initial={{ width: stroke }}
                    animate={{
                      width: [stroke, width, width],
                      transition: { duration: 0.3 },
                    }}
                    exit={{
                      width: [width, stroke, stroke],
                      x: [0, width - stroke, width - stroke],
                      y: [0, 0, 0 - height * 1.2],
                      transition: { duration: 0.3 },
                    }}
                  />
                  <CheckLine2
                    data-cy="checkmarkStroke2"
                    key="check2"
                    style={{ width: stroke }}
                    initial={{ height: stroke, x: 0 }}
                    animate={{
                      x: [0, width - stroke, width - stroke],
                      height: [stroke, stroke, height],
                      transition: { duration: 0.3 },
                    }}
                    exit={{
                      y: [0, 0, 0 - height * 1.2],
                      transition: { duration: 0.3 },
                    }}
                  />
                </>
              )}
            </AnimatePresence>
          )}
        </CheckMarkHolder>
      </CheckMarkOverflow>
    </Container>
  );
}
const Container = styled(motion.div)`
  width: 28px;
  height: 28px;
  cursor: pointer;
  position: relative;
`;

const Background = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 30px;
  overflow: hidden;
  position: absolute;
  background: radial-gradient(circle at bottom right, #98a4a5, #828c8d);
  z-index: 1;
`;
const CheckedBackground = styled(Background)`
  background: radial-gradient(circle at top left, #00b44e, #24ce7b);
  opacity: 0;
  transition: opacity 0.2s;
  ${Container}.on & {
    opacity: 1;
    transition-delay: 0.2s;
  }
`;
const Border = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 200;
  border-radius: 30px;
  border: 2px solid #828c8d;
  transition: border 0.2s;
  ${Container}:not(.on):hover & {
    border: 2px solid #384a5d;
  }
  ${Container}.on & {
    border: 2px solid #00b44e;
    transition-delay: 0.2s;
  }
`;
const CheckMarkOverflow = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 100;
  border-radius: 30px;
`;
const CheckMarkHolder = styled.div`
  width: 10px;
  height: 16px;
  position: relative;
  z-index: 100;
  margin-top: -10%;
  margin-right: -5%;
  transform: rotate(45deg);
`;
const CheckLine1 = styled(motion.div)`
  background: #eceff0;
  left: 0;
  bottom: 0;
  position: absolute;
  width: 100%;
  border-radius: 40px;
`;
const CheckLine2 = styled(motion.div)`
  background: #eceff0;
  left: 0;
  bottom: 0;
  height: 100%;
  position: absolute;
  border-radius: 40px;
`;
